(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ivvi-loox-rating"] && !Shopify.designMode) return;
  try {
    (function () {
    function bindRating(rating) {
      if (rating.dataset.ivviLooxSkeletonBound === 'true') return;
      rating.dataset.ivviLooxSkeletonBound = 'true';

      var skeleton = rating.querySelector('.loox-skeleton-placeholder');
      if (!skeleton) return;

      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.type !== 'childList' || !m.addedNodes.length) continue;
          var hasLoox = Array.prototype.some.call(m.addedNodes, function (node) {
            return node.nodeType === 1 && !node.classList.contains('loox-skeleton-placeholder');
          });
          if (hasLoox) {
            skeleton.style.display = 'none';
            observer.disconnect();
            return;
          }
        }
      });

      observer.observe(rating, { childList: true, subtree: true });

      window.setTimeout(function () {
        if (skeleton.style.display !== 'none') skeleton.style.display = 'none';
        observer.disconnect();
      }, 3000);
    }

    function scan(root) {
      (root || document).querySelectorAll('.ivvi-loox-rating.loox-rating').forEach(bindRating);
    }

    scan();

    if (!window.__ivviLooxSkeletonSectionListener) {
      window.__ivviLooxSkeletonSectionListener = true;
      document.addEventListener('shopify:section:load', function (ev) {
        if (ev.target) scan(ev.target);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
